import { useId, type ReactNode } from 'react';
import { cx } from '../../utils/cx';
import s from './SegmentedControl.module.css';

export type SegmentedControlProps<V extends string> = {
  label: string;
  options: Array<{ value: V; label: ReactNode }>;
  value: V;
  onValueChange: (value: V) => void;
  fullWidth?: boolean;
  className?: string;
};

/** A compact exclusive choice (Agenda/Month, To buy/Bought/All). Native radios under the hood. */
export function SegmentedControl<V extends string>({
  label,
  options,
  value,
  onValueChange,
  fullWidth,
  className,
}: SegmentedControlProps<V>) {
  const name = useId();
  return (
    <fieldset className={cx(s.control, className)} data-full={fullWidth || undefined}>
      <legend className={s.legend}>{label}</legend>
      {options.map((o) => (
        <label key={o.value} className={s.segment} data-checked={o.value === value || undefined}>
          <input
            type="radio"
            name={name}
            value={o.value}
            checked={o.value === value}
            onChange={() => onValueChange(o.value)}
            className={s.input}
          />
          {o.label}
        </label>
      ))}
    </fieldset>
  );
}
